<template>
  <div class="row justify-center" v-if="!selectedTutorial">
    <div
      class="q-pa-sm"
      v-for="(tutorial, index) in tutorials"
      :key="`tutorial_${index}`"
    >
      <q-img
        @click="selectedTutorial = tutorial"
        class="tutorialImage"
        :src="tutorial.thumbnail"
        style="height: 300px; width: 200px"
      >
      </q-img>
    </div>
  </div>
  <div v-else class="row" style="height: calc(90vh - 100px);">
    <div class="col-12">
      <q-btn
        icon="mdi-arrow-left"
        flat
        @click="selectedTutorial = null"
      ></q-btn>
    </div>

    <div style="width: 90%; height: 100%; margin: auto; padding: 20px">
      <iframe
        width="100%"
        height="100%"
        :src="
          `https://www.youtube.com/embed/${selectedTutorial.youtubeLink}?&autoplay=1`
        "
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      tutorials: "tutorials/listBySection",
      tutorialsLoading: "tutorials/listBySectionLoading"
    })
  },
  data: () => ({
    selectedTutorial: null
  }),
  beforeCreate() {},
  mounted() {
    this.init();
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.tutorialImage {
  transition: box-shadow 250ms;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 0px 15px 0px #c4c4c4 !important;
  }
}
</style>
